import React, {Component} from "react";
import panelby1 from "../../../assets/img/panelby1.png";
import panelby2 from "../../../assets/img/panelby2.png";

class PanelByJLCPCB extends Component {

    render() {
        return (
            <div className="container-fluid">
                <p>
                    KITCUによるシート面付けをご希望の場合
                </p>
                <div className="row">
                    <img src={panelby1} className="img-begin1"/>
                </div>
                <p>
                    下記のシート面付けをご希望の場合、X=5、Y=2と入力して下さい。
                </p>
                <div className="row">
                    <img src={panelby2} className="img-begin1"/>
                </div>
                <li>
                    1. 次のような場合はVカットによるシート面付けは対応できません。
                    シートサイズの長さが70mmより小さい場合
                </li>
                <li>２．円、長方形、正方形または三角形のような規則的な基板によるシート面付けです
                    複雑な基板外形の場合は、お客様側にてシート形状データにてご注文お願いします。
                </li>
                <li>３．板厚による最大シートサイズ
                    <ul> t0.6mmの場合 最大100mm×100mm
                    </ul>
                    <ul> t0.8から1.2mmの場合 最大200×200mm
                    </ul>
                    <ul> t1.6mmの場合 最大300×300mm
                    </ul>
                </li>

            </div>
        );
    }
}

export default PanelByJLCPCB;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PanelByJLCPCB.js